if (!customElements.get("build-a-box-controller")) {
  class BuildABoxContainer extends HTMLElement {
    constructor() {
      // NOTE multiple subscription timelines not implmented yet may need additional work later
      super();
      // CONSTS
      // BREAKPOINT CONFIG FOR PRODUCT AREA
      this.MED_BP = 768;
      this.LG_BP = 1024;

      this.SCROLL_ADJUST = 100;

      this.RESIZE_DEBOUNCE_TIMEOUT = 100;
      this.CURRENCY_DIVISOR = 100;

      this.MONEY_FORMATTER = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });

      this.QUERY_PARAM = "gbyo";
      this.QUERY_PROD_DELIM = "{product}";
      this.QUERY_QUANT_DELIM = "{quantity}";
      this.QUERY_DELIM = "//";
      this.QUERY_PARAM_TEMPLATE = [
        this.QUERY_PROD_DELIM,
        this.QUERY_DELIM,
        this.QUERY_QUANT_DELIM,
      ].join("");

      this.SHIPPING_DELIM = "{x}";
      this.PRE_POP_QTY = 1;

      // GENERAL CONFIG
      this.isSubscription = false;
      this.isLoading = true;

      this.initialItemsConnected = false;
      this.connectedItems = 0;

      this.observerClass = "byo__controller--sticky";
      this.observerSentinelSelector = ".byo__hero";

      this.loaderSelector = ".byo__action-loader";
      this.inactiveLoaderClass = "byo__action-loader--inactive";
      this.actionTextSelector = ".byo__action--text";
      this.actionWrapperSelector = ".byo__action";
      this.subLabelSelector = ".byo__sub-label";
      this.subWrapperSelector = ".byo__sub-wrapper";

      this.subtotalSelector = ".byo__subtotal";
      this.loadingOverlaySelector = ".byo__loading-overlay";
      this.productsContainerSelector = ".byo__selected-products";
      this.productsWindowSelector = ".byo__selected-products-window";
      this.shippingStringSelector = ".byo__shipping-threshold";

      this.actionSelector = ".byo__action ";
      this.actionInactiveClass = "byo__action--disabled";

      this.subscriptionSelector = ".byo__subscription";
      this.hiddenProductClass = "byo__hidden-product";

      this.mobileCount = this.dataset.mobileCount === "one" ? 1 : 2;

      this.tabletCount =
        this.dataset.tabletCount === "two"
          ? 2
          : this.dataset.tabletCount === "three"
          ? 3
          : 4;
      this.desktopCount =
        this.dataset.desktopCount === "three"
          ? 3
          : this.dataset.desktopCount === "four"
          ? 4
          : 5;

      this.minPurchase = parseInt(this.dataset.minPurchase) || 0;
      this.shippingThreshold = parseInt(this.dataset.shippingThreshold) || 0;
      this.subscriptionShippingThreshold =
        parseInt(this.dataset.subShippingThreshold) || 0;

      this.hasShippingThreshold = this.dataset.hasShippingThreshold;
      this.shippingThresholdString = this.dataset.shippingThresholdString;
      this.shippingMetString = this.dataset.shippingMetString;

      this.cartData = this.dataset.baseCart || {};

      this.action = this.dataset.action;

      this.prePopulatedProducts = this.dataset.prePop
        ? this.dataset.prePop.split(",")
        : [];

      this.products = [];
      this.observer = null;
    }
    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        const context = this,
          args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
    connectedCallback() {
      try {
        if (this.cartData && this.cartData instanceof String) {
          this.cartData = JSON.parse(this.cartData);
        } else {
          this.cartData = {};
        }
      } catch (err) {
        console.log("Initial Cart Error:", err);
        this.cartData = {};
      }
      setTimeout(() => {
        this.initializeProducts();
        this.attachListeners();
        this.setupIntersectionObserver();
      });
    }
    setupIntersectionObserver() {
      const sentinel = document.querySelector(this.observerSentinelSelector);

      const handler = (entries) => {
        if (!entries[0].isIntersecting) {
          if (!this.classList.contains(this.observerClass)) {
            this.classList.add(this.observerClass);
          }
        } else {
          this.classList.remove(this.observerClass);
        }
      };

      if (sentinel) {
        const options = {
          rootMargin: "-50px 0px 0px 0px",
          threshold: [0, 0.4, 0.45, 0.5, 0.55, 0.6],
        };
        this.observer = new window.IntersectionObserver(handler, options);
        this.observer.observe(sentinel);
      }
    }
    initializeProducts() {
      this.addFilledProducts();
      if (!this.products.length) {
        this.addEmptyProducts();
        this.addEmptyProducts();
      } else {
        this.addEmptyProducts();
      }
      this.handleSubscriptionChange();
    }
    addFilledProducts() {
      const generateProductToAdd = (id, quantity) => {
        const matchingProduct = document.querySelector(
          `[data-product-id="${id}"]`
        );
        if (matchingProduct) {
          if (customElements.get("build-a-box-item")) {
            const alreadyAdded = productsToAdd.find(
              (product) => product.dataset.productId == id
            );
            if (alreadyAdded) {
              alreadyAdded.quantity = alreadyAdded.quantity + quantity;
            } else {
              const newItem = document.createElement("build-a-box-item");
              newItem.dataset.productId = id;
              newItem.dataset.quantity = quantity;
              newItem.dataset.image = matchingProduct.dataset.productImage;
              newItem.dataset.subscription =
                matchingProduct.dataset.subscriptionMapping;
              newItem.dataset.price = matchingProduct.dataset.price;
              newItem.setAttribute("is-empty", false);
              productsToAdd.push(newItem);
            }
          }
        }
      };

      const productsToAdd = [];
      if (this.prePopulatedProducts.length) {
        this.prePopulatedProducts.forEach((product) => {
          generateProductToAdd(product, this.PRE_POP_QTY);
        });
      }
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has(this.QUERY_PARAM)) {
        const products = searchParams.get(this.QUERY_PARAM).split(",");
        products.forEach((product) => {
          const [id, quantity] = product.split(this.QUERY_DELIM);
          generateProductToAdd(id, quantity);
        });
      }

      if (this.cartData.items) {
        this.cartData.items.forEach((item) => {
          // NOTE We're going to take the cart as source of truth
          const queryParamedProduct = productsToAdd.findIndex(
            (prod) =>
              parseInt(prod.dataset.productId) === parseInt(item.variant_id)
          );
          if (queryParamedProduct > -1) {
            productsToAdd.splice(queryParamedProduct, 1);
          }
          generateProductToAdd(item.variant_id, item.quantity);
        });
      }

      this.addProductsToContainer(productsToAdd);
    }
    addEmptyProducts() {
      const productsToAdd = [];
      const addCount = this.getEmptyRowAmount();
      for (let x = 0; x < addCount; x++) {
        productsToAdd.push(this.createEmptyProduct());
      }
      this.addProductsToContainer(productsToAdd);
    }
    updateQueryParams() {
      const searchParams = new URLSearchParams(window.location.search);

      this.products.filter((product) => !product.isItemEmpty());
      const queryParamVal = this.products
        .filter((product) => !product.isItemEmpty())
        .map((product) => {
          return this.QUERY_PARAM_TEMPLATE.replace(
            this.QUERY_PROD_DELIM,
            product.productId
          ).replace(this.QUERY_QUANT_DELIM, product.quantity);
        })
        .toString();
      if (queryParamVal) {
        searchParams.set(this.QUERY_PARAM, queryParamVal);
      } else if (searchParams.has(this.QUERY_PARAM)) {
        searchParams.delete(this.QUERY_PARAM);
      }
      history.replaceState(
        history.state,
        "",
        [window.location.pathname, searchParams.toString()].join("?")
      );
    }
    addProductsToContainer(productsToAdd) {
      const productContainer = this.querySelector(
        this.productsContainerSelector
      );
      if (productContainer) {
        productsToAdd.forEach((product) => {
          productContainer.appendChild(product);
          this.products.push(product);
        });
      }
    }
    removeProductsFromContainer(removeCount) {
      const productContainer = this.querySelector(
        this.productsContainerSelector
      );
      if (productContainer) {
        const productsInContainer = [...productContainer.children];
        const reverseProducts = productsInContainer.reverse();
        const productsToRemove = [];
        for (let x = 0; x < removeCount; x++) {
          productsToRemove.push(reverseProducts[x]);
        }
        productsToRemove.forEach((product) => product.remove());
      }
    }
    updateProductInContainer(index, product) {
      const productContainer = this.querySelector(
        this.productsContainerSelector
      );
      if (productContainer) {
        const productsInContainer = [...productContainer.children];
        const childToReplace = productsInContainer[index];
        productContainer.replaceChild(product, childToReplace);
      }
    }
    attachListeners() {
      const action = this.querySelector(this.actionSelector);
      if (action) {
        action.addEventListener("click", this.handleBYOAction.bind(this));
      }

      const subscriptionTrigger = this.querySelector(this.subscriptionSelector);
      if (subscriptionTrigger) {
        subscriptionTrigger.addEventListener(
          "change",
          this.handleSubscriptionChange.bind(this)
        );
      }

      document.addEventListener("add-to-box", (e) => {
        this.handleAddToBox(e);
      });
      document.addEventListener("item-emptied", (e) => {
        document.dispatchEvent(new CustomEvent("box-builder-processing"));
        this.adjustEmptyPositions();
        if (this.action !== "atc") {
          this.removeItemFromCart(e.detail.product);
        } else {
          document.dispatchEvent(new CustomEvent("box-builder-processed"));
        }
      });
      document.addEventListener("item-removed", (e) => {
        document.dispatchEvent(new CustomEvent("box-builder-processing"));
        if (this.action !== "atc") {
          this.handleSingleItemCartEvents(e.detail.product);
        } else {
          document.dispatchEvent(new CustomEvent("box-builder-processed"));
        }
        this.update();
      });
      document.addEventListener("item-added", (e) => {
        if (this.action !== "atc") {
          document.dispatchEvent(new CustomEvent("box-builder-processing"));
          this.handleSingleItemCartEvents(e.detail.product);
        }
        this.update();
      });
      document.addEventListener(
        "item-intialized",
        this.handleItemsLoading.bind(this)
      );
      window.addEventListener(
        "resize",
        this.debounce(
          this.updateEmptyProducts.bind(this),
          this.RESIZE_DEBOUNCE_TIMEOUT
        )
      );
      document.addEventListener(
        "box-builder-processed",
        this.toggleLoadingStates.bind(this, false)
      );
      document.addEventListener(
        "box-builder-processing",
        this.toggleLoadingStates.bind(this, true)
      );
    }

    handleSubscriptionChange(e) {
      const target = e
        ? e.target
        : document.querySelector(this.subscriptionSelector);
      const possibleProducts = document.querySelectorAll("build-a-box-product");
      if (target && target.checked) {
        this.isSubscription = true;
        const productsToRemove = [];
        possibleProducts.forEach((product) => {
          if (Object.keys(product.subscriptionMapping).length) {
            if (product.classList.contains(this.hiddenProductClass)) {
              product.classList.remove(this.hiddenProductClass);
            }
          } else {
            productsToRemove.push(product.productId);
            if (!product.classList.contains(this.hiddenProductClass)) {
              product.classList.add(this.hiddenProductClass);
            }
          }
        });
        this.products.forEach((product) => {
          if (productsToRemove.includes(product.productId)) {
            product.removeProduct();
          }
          this.updateItemPrices(product);
        });
      } else {
        this.isSubscription = false;
        possibleProducts.forEach((product) => {
          if (product.classList.contains(this.hiddenProductClass)) {
            product.classList.remove(this.hiddenProductClass);
          }
        });
        this.products.forEach((product) => {
          this.updateItemPrices(product);
        });
      }
      this.adjustEmptyPositions();
      this.update();
    }
    handleItemsLoading() {
      this.connectedItems += 1;
      if (
        this.connectedItems === this.products.length &&
        !this.initialItemsConnected
      ) {
        this.update();
        this.activateController();
      }
    }
    updateEmptyProducts() {
      const productsToAdd = [];
      // We would look at the array and ensure that there is at least one full empty row
      const emptyAmount = this.getEmptyRowAmount();
      const emptyItems = this.products.filter((item) =>
        item.isItemEmpty()
      ).length;

      const filledItems = this.products.length - emptyItems;
      // This has a partially filled row
      const unfilledRowEmpties = filledItems % emptyAmount;

      const fillEmptyRows = () => {
        while (
          (this.products.length + productsToAdd.length) % emptyAmount !==
          0
        ) {
          productsToAdd.push(this.createEmptyProduct());
        }
        this.addProductsToContainer(productsToAdd);
      };

      if (unfilledRowEmpties !== 0) {
        // Maximum == One Additional Row + Remainder
        const maxIfUnfilledRow =
          emptyAmount + (emptyAmount - unfilledRowEmpties);

        if (emptyItems >= maxIfUnfilledRow) {
          const itemsToRemove = emptyItems - maxIfUnfilledRow;
          this.removeEmptyProducts(itemsToRemove);
        } else {
          fillEmptyRows();
        }
      } else {
        const maxIfFilledRow = emptyAmount * 2;
        if (emptyItems >= maxIfFilledRow) {
          // Keeping at most 2 rows of empties
          const itemsToRemove = emptyItems - maxIfFilledRow;
          this.removeEmptyProducts(itemsToRemove);
        } else {
          if (unfilledRowEmpties === 0) {
            for (let x = 0; x < emptyAmount; x++) {
              productsToAdd.push(this.createEmptyProduct());
            }
          } else {
            fillEmptyRows();
          }
          this.addProductsToContainer(productsToAdd);
        }
      }
    }
    removeEmptyProducts(removalCount) {
      this.products = this.products.splice(
        0,
        this.products.length - removalCount
      );
      this.removeProductsFromContainer(removalCount);
    }
    getEmptyRowAmount() {
      if (window.innerWidth < this.MED_BP) {
        return this.mobileCount;
      } else if (window.innerWidth < this.LG_BP) {
        return this.tabletCount;
      }
      return this.desktopCount;
    }
    activateController() {
      // TODO find a better solution here
      setTimeout(() => {
        this.isLoading = false;
        const loadingOverlay = this.querySelector(this.loadingOverlaySelector);
        if (loadingOverlay) {
          loadingOverlay.addEventListener("transitionend", () => {
            loadingOverlay.style.visibility = "hidden";
          });
          loadingOverlay.style.opacity = 0;
        }
        document.dispatchEvent(new Event("box-builder-loaded"));
      }, 300);
    }
    toggleLoading() {
      setTimeout(() => {
        this.isLoading = true;
        const loadingOverlay = this.querySelector(this.loadingOverlaySelector);
        if (loadingOverlay) {
          loadingOverlay.addEventListener("transitionend", () => {
            loadingOverlay.style.opacity = 1;
          });
          loadingOverlay.style.visibility = "visbile";
        }
        document.dispatchEvent(new Event("box-builder-loaded"));
      }, 300);
    }
    handleAddToBox(e) {
      let workingProd = this.products.find((product) => {
        return product.productId === e.detail.prod;
      });
      if (workingProd) {
        workingProd.increment();
      } else {
        workingProd = this.products.find((product) => product.isItemEmpty());
        workingProd.setProduct(e.detail);
        if (this.action !== "atc") {
          document.dispatchEvent(new CustomEvent("box-builder-processing"));
          this.handleSingleItemCartEvents(workingProd);
        }
        this.updateItemPrices(workingProd);
      }
      this.moveToProduct(workingProd);
      this.update();
    }
    moveToProduct(product) {
      const productWindow = this.querySelector(this.productsWindowSelector);
      if (productWindow) {
        let newLeft = this.offsetLeft;
        let newTop = this.offsetTop;
        if (this.classList.contains(this.observerClass)) {
          newLeft = product.offsetLeft - this.SCROLL_ADJUST;
          newTop = 0;
        } else {
          newTop = product.offsetTop - this.SCROLL_ADJUST;
          newLeft = 0;
        }
        productWindow.scrollTo(newLeft, newTop);
      }
    }
    updateProductValues(product) {
      product.dataset.quantity += 1;
      const visibleQuantity = product.querySelector(this.quantityClass);
      if (visibleQuantity) {
        visibleQuantity.innerText = product.dataset.quantity;
      }
    }
    createEmptyProduct() {
      if (customElements.get("build-a-box-item")) {
        const newItem = document.createElement("build-a-box-item");
        newItem.setAttribute("is-empty", "true");
        return newItem;
      }
    }
    getSubtotal() {
      const sumMoney = this.products.reduce((accumulator, currentVal) => {
        return accumulator + currentVal.quantity * currentVal.price;
      }, 0);
      let money = sumMoney / this.CURRENCY_DIVISOR;
      if (isNaN(money)) {
        money = 0.0;
      }
      return money;
    }
    updateBoxSubtotal() {
      const subtotalContainer = this.querySelector(this.subtotalSelector);
      if (subtotalContainer) {
        subtotalContainer.innerText = this.MONEY_FORMATTER.format(
          this.getSubtotal()
        );
      }
    }
    updateShippingThreshold() {
      const shippingContainer = this.querySelector(this.shippingStringSelector);
      if (shippingContainer) {
        const cartPrice = this.getSubtotal();
        let activeThreshold = this.shippingThreshold;
        if (this.isSubscription && this.subscriptionShippingThreshold) {
          activeThreshold = this.subscriptionShippingThreshold;
        }
        if (cartPrice >= activeThreshold) {
          shippingContainer.innerText = this.shippingMetString;
        } else {
          const amountToDisplay = activeThreshold - cartPrice;
          shippingContainer.innerHTML = this.shippingThresholdString.replace(
            this.SHIPPING_DELIM,
            this.MONEY_FORMATTER.format(amountToDisplay)
          );
        }
      }
    }
    updateActionState() {
      const actionTrigger = this.querySelector(this.actionSelector);
      if (actionTrigger) {
        const purchasingQuantity = this.products.reduce((acc, currentVal) => {
          return acc + currentVal.quantity;
        }, 0);
        if (
          purchasingQuantity >= this.minPurchase &&
          actionTrigger.classList.contains(this.actionInactiveClass)
        ) {
          actionTrigger.classList.remove(this.actionInactiveClass);
        } else if (
          purchasingQuantity < this.minPurchase &&
          !actionTrigger.classList.contains(this.actionInactiveClass)
        ) {
          actionTrigger.classList.add(this.actionInactiveClass);
        }
      }
    }
    update() {
      if (this.hasShippingThreshold && this.shippingThreshold) {
        this.updateShippingThreshold();
      }
      this.updateActionState();
      this.updateBoxSubtotal();
      this.updateEmptyProducts();
      this.updateQueryParams();
    }
    updateItemPrices(product) {
      if (!product.isItemEmpty() && product.price) {
        // Only 1 type of subscription
        const subKeys = Object.keys(product.subscription);
        if (subKeys.length == 1) {
          if (this.isSubscription) {
            product.price = parseInt(product.subscription[subKeys[0]].price);
          } else {
            product.price = parseInt(product.dataset.price);
          }
        } else if (subKeys.length > 1) {
          // NOTE this is not currently useable
        }
      }
    }
    handleBYOAction() {
      const action = this.querySelector(this.actionSelector);
      if (action && !action.classList.contains(this.actionInactiveClass)) {
        if (this.action === "atc") {
          document.dispatchEvent(new CustomEvent("box-builder-processing"));
          this.handleSingleCartUpdate();
        } else {
          window.location.href = "/checkout";
        }
      }
    }
    async updateCart(requestData, endpoint, openCart = false) {
      await fetch(window.Shopify.routes.root + endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (!data.total_price) {
            const additionalPrice = data.items.reduce((acc, item) => {
              return acc + item.final_line_price;
            }, 0);
            data.total_price = this.cartData.total_price + additionalPrice;
          } else if (!data.items.length) {
            data.total_price = 0;
          }
          this.cartData = data;
          this.update();

          // NOTE If the cart is replaced this will need to be adjusted
          if (GND) {
            GND.sidecart.refresh();
          }
          if (openCart && RC) {
            RC.sidePanel.open("#cart_panel");
          }
        })
        .catch((error) => {
          // TODO add front end error messaging
          console.error("Error:", error);
        })
        .finally(() => {
          document.dispatchEvent(new CustomEvent("box-builder-processed"));
        });
    }
    handleSingleItemCartEvents(product) {
      const [matchingProducts, excludedProducts] =
        this.getMatchingProductObject([product]);
      if (Object.keys(matchingProducts).length) {
        const endpointUrl = "cart/update.js";
        this.updateCart({ updates: matchingProducts }, endpointUrl);
      } else if (product.productId) {
        const endpointUrl = "cart/add.js";
        const itemObject = {
          id: parseInt(product.productId),
          quantity: product.quantity,
        };
        if (this.isSubscription) {
          const subKeys = Object.keys(product.subscription);
          if (subKeys.length == 1) {
            itemObject.selling_plan = parseInt(
              product.subscription[subKeys[0]].id
            );
          } else if (subKeys > 1) {
            // Not Currently Implmented
          }
        }
        const requestData = {
          items: [itemObject],
        };
        this.updateCart(requestData, endpointUrl);
      }
    }
    handleSingleCartUpdate() {
      // const [requestData, excludedProducts] = this.getMatchingProductObject(
      //   this.products
      // );
      // if (Object.keys(requestData).length) {
      //   const endpointUrl = "cart/update.js";
      //   this.updateCart(
      //     { updates: requestData },
      //     endpointUrl,
      //     excludedProducts.length ? false : true
      //   );
      // }
      if (this.products.length) {
        const endpointUrl = "cart/add.js";
        const lineItems = [];
        this.products.forEach((item) => {
          if (item.productId) {
            const itemObject = {
              id: parseInt(item.productId),
              quantity: item.quantity,
            };
            if (this.isSubscription) {
              const subKeys = Object.keys(item.subscription);
              if (subKeys.length == 1) {
                itemObject.selling_plan = parseInt(
                  item.subscription[subKeys[0]].id
                );
              } else if (subKeys > 1) {
                // Not Currently Implmented
              }
            }
            lineItems.push(itemObject);
          }
        });
        if (lineItems.length) {
          const requestData = {
            items: lineItems,
          };
          this.updateCart(requestData, endpointUrl, true);
        }
      } else {
        document.dispatchEvent(new CustomEvent("box-builder-processed"));
      }
    }
    getMatchingProductObject(products) {
      const matchingObject = {};
      const excludedProducts = [];
      products.forEach((product) => {
        const matchingItems = this.cartData?.items?.filter((item) => {
          return parseInt(item.variant_id) === parseInt(product.productId);
        });
        if (matchingItems?.length) {
          let workingItem = matchingItems[0];
          if (matchingItems.length >= 1) {
            const subProduct = matchingItems.find(
              (item) => item.selling_plan_allocation
            );
            if (
              subProduct &&
              parseInt(subProduct.selling_plan_allocation.selling_plan.id) ===
                parseInt(product.dataset.subscription)
            ) {
              if (this.isSubscription) {
                workingItem = subProduct;
                matchingObject[workingItem.key] = product.quantity;
              } else {
                excludedProducts.push(product);
              }
            } else {
              matchingObject[workingItem.key] = product.quantity;
            }
          }
        } else if (!product.isItemEmpty()) {
          excludedProducts.push(product);
        }
      });
      return [matchingObject, excludedProducts];
    }
    updateItemCartQuantities() {
      const endpointUrl = "cart/update.js";
      const [requestData, excludedProducts] = this.getMatchingProductObject(
        this.products
      );
      this.updateCart(requestData, endpointUrl);
    }
    removeItemFromCart(product) {
      const endpointUrl = "cart/update.js";
      const [requestData, excludedProducts] = this.getMatchingProductObject([
        product,
      ]);
      if (Object.keys(requestData).length) {
        requestData[Object.keys(requestData)[0]] = 0;
        this.updateCart({ updates: requestData }, endpointUrl);
      } else {
        document.dispatchEvent(new CustomEvent("box-builder-processed"));
      }
    }
    adjustEmptyPositions() {
      let filledProducts = this.products.filter(
        (product) => !product.isItemEmpty()
      );
      const productContainer = this.querySelector(
        this.productsContainerSelector
      );
      if (productContainer && filledProducts.length) {
        // filledProducts = filledProducts.reverse();
        filledProducts.forEach((product) => {
          productContainer.removeChild(product);
        });
        productContainer.prepend(...filledProducts);
        this.products = [...productContainer.childNodes];
      }
    }
    toggleLoadingStates(isLoading) {
      this.toggleActionLoading(isLoading);
      this.toggleSubscriptionLoading(isLoading);
    }
    toggleActionLoading(isLoading) {
      const actionWrapper = this.querySelector(this.actionWrapperSelector);
      if (actionWrapper) {
        const actionText = actionWrapper.querySelector(this.actionTextSelector);
        const loader = actionWrapper.querySelector(this.loaderSelector);
        if (actionText && loader) {
          if (!isLoading) {
            if (!loader.classList.contains(this.inactiveLoaderClass)) {
              loader.classList.add(this.inactiveLoaderClass);
            }
            actionText.style.display = "inline";
          } else {
            actionText.style.display = "none";
            if (loader.classList.contains(this.inactiveLoaderClass)) {
              loader.classList.remove(this.inactiveLoaderClass);
            }
          }
        }
      }
    }
    toggleSubscriptionLoading(isLoading) {
      const subLabel = this.querySelector(this.subLabelSelector);
      if (subLabel) {
        const subWrapper = subLabel.querySelector(this.subWrapperSelector);
        const loader = subLabel.querySelector(this.loaderSelector);
        if (subWrapper && loader) {
          if (!isLoading) {
            if (!loader.classList.contains(this.inactiveLoaderClass)) {
              loader.classList.add(this.inactiveLoaderClass);
            }
            subWrapper.style.display = "inline-block";
          } else {
            subWrapper.style.display = "none";
            if (loader.classList.contains(this.inactiveLoaderClass)) {
              loader.classList.remove(this.inactiveLoaderClass);
            }
          }
        }
      }
    }
  }
  customElements.define("build-a-box-controller", BuildABoxContainer);
}
if (!customElements.get("build-a-box-item")) {
  class BuildABoxItem extends HTMLElement {
    static get observedAttributes() {
      return ["is-empty"];
    }

    constructor() {
      super();
      this.emptySelector = "#byo__empty-product";
      this.filledSelector = "#byo__filled-product";

      this.imageContainerSelector = ".byo__box-product-image-wrapper";
      this.decrementorSelector = ".byo__box-product-quantity--decrement";
      this.incrementorSelector = ".byo__box-product-quantity--increment";
      this.quantitySelector = ".byo__box-product-quantity";

      this.loaderSelector = ".byo__action-loader";
      this.inactiveLoaderClass = "byo__action-loader--inactive";
      this.quantityWrapperSelector = ".byo__box-product-quantity-wrapper";

      this.isEmpty = true;
      this.quantity = parseInt(this.dataset.quantity) || 0;
      this.price = parseInt(this.dataset.price) || 0;
      this.image = this.dataset.image || "";
      this.productId = this.dataset.productId || "";
      try {
        this.subscription = JSON.parse(this.dataset.subscription);
      } catch (err) {
        this.subscription = {};
      }
      this.emptyContentTemplate = "";
      this.filledContentTemplate = "";
    }

    connectedCallback() {
      setTimeout(() => {
        if (Object.keys(this.dataset).length) {
          this.refreshData();
        }
        this.setTemplates();
        this.initializeProduct();
      });
    }

    refreshData() {
      this.quantity = parseInt(this.dataset.quantity) || 0;
      this.price = parseInt(this.dataset.price) || 0;
      this.image = this.dataset.image || "";
      this.productId = this.dataset.productId || "";
      this.subscription = this.dataset.subscription
        ? JSON.parse(this.dataset.subscription)
        : {};
      if (this.dataset.productId) {
        this.isEmpty = false;
      }
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue) {
        if (newValue === "false") {
          this.displayProduct();
        } else {
          this.displayEmpty();
        }
      }
    }
    setTemplates() {
      const emptyTemplate = document.querySelector(this.emptySelector);
      if (emptyTemplate) {
        this.emptyContentTemplate = emptyTemplate.content.cloneNode(true);
      }
      const filledTemplate = document.querySelector(this.filledSelector);
      if (filledTemplate) {
        this.filledContentTemplate = filledTemplate.content.cloneNode(true);
      }
    }
    initializeProduct() {
      if (!this.emptyContentTemplate || !this.filledContentTemplate) {
        const errorDiv = document.createElement("div");
        errorDiv.innerText = "TEMPLATES NOT CONFIGURED";
        this.appendChild(errorDiv);
      } else {
        this.innerHTML = "";
        if (this.productId) {
          this.displayProduct();
        } else {
          this.appendChild(this.emptyContentTemplate.cloneNode(true));
        }
        document.dispatchEvent(new CustomEvent("item-intialized"));
      }
    }
    displayProduct() {
      const workingTemplate = this.filledContentTemplate.cloneNode(true);

      const imageWrapper = workingTemplate.querySelector(
        this.imageContainerSelector
      );
      if (imageWrapper) {
        const itemImage = document.createElement("img");
        itemImage.src = this.image;
        imageWrapper.appendChild(itemImage);
      }

      const quantityWrapper = workingTemplate.querySelector(
        this.quantitySelector
      );
      if (quantityWrapper) {
        quantityWrapper.innerText = this.quantity;
      }
      this.innerHTML = "";
      this.appendChild(workingTemplate);
      this.attachListeners();
    }
    displayEmpty() {
      this.innerHTML = "";
      this.appendChild(this.emptyContentTemplate.cloneNode(true));
    }
    attachListeners() {
      const decrementor = this.querySelector(this.decrementorSelector);
      if (decrementor) {
        decrementor.addEventListener("click", this.decrement.bind(this));
      }
      const incrementor = this.querySelector(this.incrementorSelector);
      if (incrementor) {
        incrementor.addEventListener("click", this.increment.bind(this));
      }
      document.addEventListener(
        "box-builder-processed",
        this.toggleQuantity.bind(this, true)
      );
      document.addEventListener(
        "box-builder-processing",
        this.toggleQuantity.bind(this, false)
      );
    }
    setProduct(details) {
      this.quantity = 1;
      this.setAttribute("data-quantity", 1);
      this.image = details.image;
      this.setAttribute("data-image", details.image);
      this.productId = details.prod;
      this.setAttribute("data-product-id", details.prod);
      this.subscription = details.subs;
      this.setAttribute("data-subscription", JSON.stringify(details.subs));
      this.price = parseInt(details.price) || 0;
      this.setAttribute("data-price", details.price);
      this.isEmpty = false;
      this.setAttribute("is-empty", this.isEmpty);
    }
    removeProduct() {
      this.quantity = 0;
      this.image = "";
      this.productId = "";
      this.subscription = "";
      this.price = 0;
      this.isEmpty = true;
      const attrs = [
        "data-quantity",
        "data-price",
        "data-image",
        "data-product-id",
        "data-subscription",
      ];
      attrs.forEach((attr) => this.removeAttribute(attr));
      this.setAttribute("is-empty", this.isEmpty);
    }
    isItemEmpty() {
      return this.isEmpty;
    }
    updateUI() {
      const quantityWrapper = this.querySelector(this.quantitySelector);
      if (quantityWrapper) {
        quantityWrapper.innerText = this.quantity;
      }
    }
    increment() {
      this.quantity += 1;
      this.setAttribute("data-quantity", this.quantity);
      this.updateUI();
      document.dispatchEvent(
        new CustomEvent("item-added", {
          detail: {
            product: this,
          },
        })
      );
    }
    decrement() {
      this.quantity -= 1;
      if (this.quantity < 1) {
        // Stashing this so we can nuke the product out of the cart
        const product = {
          productId: this.productId,
          subscription: this.subscription,
          isItemEmpty: () => true,
        };
        this.removeProduct();
        document.dispatchEvent(
          new CustomEvent("item-emptied", {
            detail: {
              product: product,
            },
          })
        );
      } else {
        this.setAttribute("data-quantity", this.quantity);
        this.updateUI();
      }
      document.dispatchEvent(
        new CustomEvent("item-removed", {
          detail: {
            product: this,
          },
        })
      );
    }
    toggleQuantity(quantityVisible) {
      const quantityWrapper = this.querySelector(this.quantityWrapperSelector);
      const loader = this.querySelector(this.loaderSelector);
      if (quantityWrapper && loader) {
        if (quantityVisible) {
          if (!loader.classList.contains(this.inactiveLoaderClass)) {
            loader.classList.add(this.inactiveLoaderClass);
          }
          quantityWrapper.style.display = "flex";
        } else {
          quantityWrapper.style.display = "none";
          if (loader.classList.contains(this.inactiveLoaderClass)) {
            loader.classList.remove(this.inactiveLoaderClass);
          }
        }
      }
    }
  }

  customElements.define("build-a-box-item", BuildABoxItem);
}

if (!customElements.get("build-a-box-product")) {
  class BuildABoxProduct extends HTMLElement {
    constructor() {
      super();

      this.ANIMATION_TIMING = 1000;

      this.canAdd = false;
      this.isShowingPrompt = true;

      this.addToBoxSelector = ".byo__add-to-box";
      this.promptSelector = ".byo__atb-indicator--prompt";
      this.successSelector = ".byo__atb-indicator--success";
      this.inactiveClass = "byo__add-to-box--inactive";

      this.productImage = this.dataset.productImage;
      this.productId = this.dataset.productId;
      try {
        this.subscriptionMapping = JSON.parse(this.dataset.subscriptionMapping);
      } catch (err) {
        this.subscriptionMapping = {};
      }
      this.price = this.dataset.price;
    }

    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }

    attachListeners() {
      this.querySelectorAll(this.addToBoxSelector).forEach((addToBox) => {
        addToBox.addEventListener("click", this.triggerAddToCart.bind(this));
      });
      document.addEventListener(
        "box-builder-loaded",
        this.activateAddToCart.bind(this)
      );
      document.addEventListener(
        "box-builder-processed",
        this.activateAddToCart.bind(this)
      );
      document.addEventListener(
        "box-builder-processing",
        this.deactivateAddToCart.bind(this)
      );
    }
    deactivateAddToCart() {
      this.canAdd = false;
      this.querySelectorAll(this.addToBoxSelector).forEach((addToBox) => {
        addToBox.classList.add(this.inactiveClass);
      });
    }
    activateAddToCart() {
      this.canAdd = true;
      this.querySelectorAll(this.addToBoxSelector).forEach((addToBox) => {
        addToBox.classList.remove(this.inactiveClass);
      });
    }
    triggerAddToCart() {
      if (this.canAdd) {
        document.dispatchEvent(
          new CustomEvent("add-to-box", {
            detail: {
              prod: this.productId,
              subs: this.subscriptionMapping,
              image: this.productImage,
              price: this.price,
            },
          })
        );
      }
    }
  }
  customElements.define("build-a-box-product", BuildABoxProduct);
}
